
import React, { useEffect, useState } from 'react'
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
import Swapform from '../../Presale/Swapform';
import { useDispatch, useSelector } from 'react-redux';
import * as ACTIONTYPES from '../../../../redux/actionTypes'
import { getUsdtBalance } from '../../../Web3/Connector';
import { Spin } from 'antd';
import config from '../../../../config';
import { useNavigate } from 'react-router-dom';
// import Web3ModalProvider from '../Connectwallet/Web3ModalProvider';
import Web3ModalProvider from '../../Presale/Connectwallet/Web3ModalProvider';
import { useDisconnect } from 'wagmi';
import { Warning } from '../../../../utils/errors';
// import { useDisconnect, useWeb3ModalProvider } from '@web3modal/ethers/react';




const Presalesecondstage1 = ({ openBuyForm, setOpenBuyForm, setconnectWalletNow, InfiTokenPrice, UsdtContract, presaleContract }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const _useDisconnect = useDisconnect();
    const _useWeb3ModalProvider = Web3ModalProvider()

    const loginDetails = useSelector((state) => state.auth.LoginDetails);
    const walletConnnected = useSelector((state) => state.auth.walletConnnected);
    const [WalletAddress, setWalletAddress] = useState("")
    const [show, setShow] = useState(false);
    const [usdtBalance, setUsdtBalance] = useState(0);
    const [UsdtAllowance, setUsdtAllowance] = useState(0);
    const [IsProcessing, setIsProcessing] = useState(false);

    const BuyInfiClose = () => {
        setShow(false);
        setOpenBuyForm(false)
    }
    const BuyInfi = async () => {
        if (!loginDetails?.isLogin) {
            navigate(`${config.baseurl}login`);
            return;
        }
        if (WalletAddress) {
            if (WalletAddress.toUpperCase() != loginDetails.walletAddress.toUpperCase()) {
                Warning("Please connect with registered wallet")
                return;
            }
            let res = await getWalelletDetails(WalletAddress)
            if (!res.status) {
                Warning(res.message)
                return;
            }
            setShow(true);
        } else {
            setconnectWalletNow(true)
        }
    }

    useEffect(() => {
        if (loginDetails?.isLogin) {
            setWalletAddress(walletConnnected);
        }
    }, [walletConnnected])

    useEffect(() => {
        if (walletConnnected && UsdtContract && presaleContract) {
            getWalelletDetails(walletConnnected);
        }
    }, [walletConnnected, UsdtContract, presaleContract])
    useEffect(() => {
        setShow(openBuyForm)
    }, [openBuyForm])

    const disconnectWallet = () => {

        _useDisconnect.disconnect()
        dispatch({ type: ACTIONTYPES.walletConnnected, payload: "" });
    }
    const getWalelletDetails = async (wallet) => {
        const res = await getUsdtBalance(wallet, UsdtContract, presaleContract, _useWeb3ModalProvider);
        setUsdtBalance(res?.balance || 0)
        setUsdtAllowance(res?.allowance || 0)
        return res;
    }

    return (
        <>
            {/* <div className="">
            <h1 className='text-blue text-uppercase display-3'><b>Stage&nbsp;1</b></h1>
            <div className='text-center cardBox mt-5'>
                <div>1 USDT = 4166.67 INFI Infinity</div>

                <h1 className='text-gradient'><b>$2.5 per token</b></h1>
                <div className='d-flex gap-2 mt-4 mb-4 justify-content-center'>
                    <Button variant='outline-blue'>400k tokens for sale!</Button>
                    <Button variant='outline-blue'>800k tokens sold!</Button>
                </div>
                <Button variant='primary' className='text-black w-100 fs-6'><b>CONNECT WALLET</b></Button>
            </div>
        </div> */}

            {/* --------------------------------- */}
            <div className="stageBox">
                <h1 className='text-blue text-uppercase fw-bold display-3'><b>Stage 1</b></h1>
                <div className='stageblock p-5'>
                    {/* <div className='text-black fs-2'>1 INFI = {InfiTokenPrice} USDT</div> */}
                    <div className='text-black fs-2 mb-2'>1 USDT = 4166.67 INFI Infinity </div>

                    {/* <h4 className='text-gradient'><b>{!WalletAddress ? 'CONNECT WALLET' : 'CONNECTED WALLET'}</b></h4> */}
                    <h5 className='text-gradient fs-1 mb-3'>CONNECTED WALLET</h5>
                    <h6 className='text-uppercase text-primary fs-5 mb-3'>0x117F26717BF9344fdeA0AE55Cc87C0AB94E8E0dD</h6>
                    {WalletAddress && <small className='mb-0 text-white text-break'>{WalletAddress}</small>}
                    {/* <div className=' mt-4 mb-4'>
                        <Button variant='primary' className='text-black w-100 mb-3 text-uppercase fs-6' onClick={BuyInfi}><b>buy infi</b></Button>
                        {WalletAddress && <Button onClick={disconnectWallet} variant='primary' className='text-black w-100 text-uppercase fs-6'><b>disconnect</b></Button>}
                    </div> */}

                    <div className='mt-4'>
                        <Button variant='custombtn2' className='py-2 w-100 fw-bold mb-3' style={{ letterSpacing: "1.1px" }}>
                            BUY INFI
                        </Button>
                        <Button variant='custombtn2' className='py-2 w-100 fw-bold' style={{ letterSpacing: "1.1px" }}>
                            DISCONNECT
                        </Button>
                    </div>

                    <div className='promocodebox mt-3'>
                        <Form>
                            <Form.Group className="promoblock">
                                <Form.Control type="text" placeholder="PROMO CODE" className='promoinputdiv' />
                                <div className='promocheckbox'>
                                    <Form.Check type="checkbox" />
                                </div>
                            </Form.Group>
                        </Form>
                    </div>

                </div>
            </div>
            {/* -----Connect Wallet----- */}
            <Modal backdrop={'static'} onEscapeKeyDown={(e) => e.preventDefault()} show={show} onHide={BuyInfiClose} centered>
                <Spin spinning={IsProcessing}>
                    <Modal.Header >
                        <Modal.Title></Modal.Title>
                    </Modal.Header>

                    <Modal.Body className=''>
                        <Row className="justify-content-center">
                            <Col lg={11}>
                                <Swapform
                                    usdtBalance={usdtBalance}
                                    InfiTokenPrice={InfiTokenPrice}
                                    walletConnnected={walletConnnected}
                                    UsdtContract={UsdtContract}
                                    presaleContract={presaleContract}
                                    setIsProcessing={setIsProcessing}
                                    BuyInfiClose={BuyInfiClose}

                                />
                            </Col>
                        </Row>

                    </Modal.Body>
                </Spin>
            </Modal>
            {/* ------------- */}
        </>


    );
}

export default Presalesecondstage1;